export default function SkeletonSection({ width }: { width: string }) {
    return (
        <div className={`bg-skeleton-light w-${width} h-2 rounded`}></div>
    )
};
